module.exports = __webpack_public_path__ + "static/deal-a2392ed50968140ea920938f8793e06b.jpg";